'use strict';

document.addEventListener('DOMContentLoaded', function() {
    (function() {
        // Create a modal element
        const customModal = document.createElement('div');
        customModal.id = 'customModal';
        customModal.style.display = 'none'; // Start hidden
        customModal.style.position = 'fixed';
        customModal.style.zIndex = '8';
        customModal.style.left = '0';
        customModal.style.top = '0';
        customModal.style.width = '100%';
        customModal.style.height = '100%';
        customModal.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        customModal.style.justifyContent = 'center';
        customModal.style.alignItems = 'center';
        customModal.style.transition = '0.3s';

        const modalContent = document.createElement('div');
        modalContent.className = 'modal-content';
        modalContent.style.backgroundColor = '#fff';
        modalContent.style.padding = '20px';
        modalContent.style.borderRadius = '5px';
        modalContent.style.position = 'relative';
        modalContent.style.maxWidth = '500px'; // Set a max width for the modal
        modalContent.style.margin = 'auto'; // Center the modal content

        const closeButton = document.createElement('span');
        closeButton.textContent = '×';
        closeButton.style.position = 'absolute';
        closeButton.style.right = '10px';
        closeButton.style.top = '10px';
        closeButton.style.cursor = 'pointer';
        closeButton.style.fontSize = '20px';
        modalContent.appendChild(closeButton);

        customModal.appendChild(modalContent);
        document.body.appendChild(customModal);

        // Show the modal
        function showModal(content) {
            modalContent.insertAdjacentHTML('beforeend', content);
            customModal.style.display = 'flex'; // Show the modal
        }

        // Hide the modal
        function hideModal() {
            modalContent.innerHTML = ''; // Clear the content
            modalContent.appendChild(closeButton); // Keep the close button
            customModal.style.display = 'none'; // Hide the modal
        }

        // Event listener for the close button
        closeButton.onclick = hideModal;

        // Close the modal on Escape key press
        document.onkeydown = function(event) {
            if (event.key === 'Escape') {
                hideModal();
            }
        };

        // Close the modal when clicking outside of modal content
        customModal.addEventListener('click', function(e) {
            if (e.target === customModal) {
                hideModal();
            }
        });

        document.body.addEventListener('click', function(e) {
            if (e.target.classList.contains('js-wbquickview-link')) {
                e.preventDefault();
                const currentTarget = e.target;
                const productUrl = currentTarget.dataset.url;
                const variantId = currentTarget.getAttribute('variant-id');
                let url = productUrl;

                if (productUrl.indexOf("?") > 0) {
                    url = productUrl.substring(0, productUrl.indexOf("?"));
                }

                fetch(url + '?view=wbquickview' + (variantId !== undefined ? '&variant=' + variantId : ''))
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.text();
                    })
                    .then(data => {
                        if (!data) { return; }
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(data, 'text/html');
                        const html = doc.querySelector('[data-html="content"]');

                        if (html) {
                            // Set the fetched HTML to the modal and show it
                            showModal(html.innerHTML);
                        } else {
                            console.error('Content not found in fetched data');
                        }

                        // Add event listener to "Add to Cart" button
                        const addToCartButtonListener = function(event) {
                            if (event.target.classList.contains('product-form__submit')) {
                                setTimeout(function() {
                                    hideModal();
                                }, 1200);
                            }
                        };

                        document.addEventListener('click', addToCartButtonListener, { once: true });

                    })
                    .catch(error => {
                        console.error('There was a problem with the fetch operation:', error);
                    });
            }
        });

        // Ensure modal is closed on page refresh
        window.addEventListener('beforeunload', hideModal);

    })();
});
